import type React from "react";
import {Skeleton, Stack, Typography} from "@mui/material";
import type {SupplierEntity} from "~/pages/supplier-360/types/Supplier360Types";
import {useValueChainTreeQuery} from "~/pages/supplier-360/tabs/SupplierValueChain/hooks/useValueChainTreeQuery";
import {ValueChainBoard} from "~/pages/supplier-360/tabs/SupplierValueChain/components/chain/ValueChainBoard";

/** The unlocked chain view (§3.9). The summary side panel is hidden until the API has enough data to fill it. */
export const ValueChainSection: React.FC<{entity: SupplierEntity}> = ({entity}) => {
    const treeQuery = useValueChainTreeQuery(entity.id);
    const tree = treeQuery.data;

    if (treeQuery.isLoading) {
        return <Skeleton variant="rectangular" height={240} sx={{borderRadius: 1}}/>;
    } else if (treeQuery.isError || !tree) {
        return <Stack alignItems="center" justifyContent="center" sx={{mt: 5}}><Typography variant="body2" color="text.secondary">Value chain links could not be loaded.</Typography></Stack>;
    } else if (tree.upstream.length === 0 && tree.downstream.length === 0) {
        return <Stack alignItems="center" justifyContent="center" sx={{mt: 5}}><Typography variant="body2" color="text.secondary">No value chain links for this supplier yet.</Typography></Stack>;
    } else {
        return <ValueChainBoard entity={entity} tree={tree}/>;
    }
};
